import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CryptoJsService } from '@core/utils/crypto-js/crypto-js.service';
import { IInstallation } from '@modules/clients/models/installation';
import { firstValueFrom, map } from 'rxjs';
import { GlobalStateService } from 'src/app/shared/services/global-state/global-state.service';
import { environment } from 'src/environments/environment';

export interface ICompanySocialLinks {
  number: number;
  defaultMessage: string;
  type: string;
}

export interface IMethodPayment {
  name: string;
  isActive: boolean;
  percentage: number | null;
  const: number | null;
  maxAmount: number | null;
}

export interface ICompanyOwner {
  id: number;
  nameCompany: string;
  rifCompany: string;
  directionCompany: string;
  phoneCompany: string;
  isMain: boolean;
  socialLinks: Array<ICompanySocialLinks>;
  methodPayment: Array<IMethodPayment>;
  maintenance: boolean;
  installations?: IInstallation[] | number[];
  isBlockApiDoc: boolean;
  enabledJobCutService: boolean;
  enabledReconnectionFee: boolean;
  logo: string;
}

export const companiesSelect = [
  { key: 1, value: 'Chircalnet' },
  { key: 2, value: 'Boom' },
];

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  constructor(
    private readonly http: HttpClient,
    private readonly cryptoJsService: CryptoJsService,
    private readonly globalStateService: GlobalStateService,
  ) {}

  getCompanies(): Promise<ICompanyOwner[]> {
    return firstValueFrom(
      this.http.get<ICompanyOwner[]>(`${environment.apiUrl}/company-owner/all`).pipe(
        map((companies: any) => {
          const companiesDecrypted = this.cryptoJsService.decryptObject(companies.data, 'ye43@^(csd)m');
          this.globalStateService.setCompanies(companiesDecrypted);
          return companiesDecrypted;
        }),
      ),
    );
  }

  getCompanyById(id: number): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${environment.apiUrl}/company-owner/${id}`));
  }

  updateCompany(id: number, data: any): Promise<any> {
    return firstValueFrom(this.http.put<any>(`${environment.apiUrl}/company-owner/${id}`, data));
  }

  getQRWhatsapp(id: number): Promise<Blob> {
    return firstValueFrom(
      this.http.get<Blob>(`${environment.apiUrl}/bot-whatsapp/qr`, { responseType: 'blob' as 'json' }),
    );
  }
  /**
   * getCheckStatusWhatsappBot
   */
  public getCheckStatusWhatsappBot() {
    return firstValueFrom(this.http.get<any>(`${environment.apiUrl}/bot-whatsapp/check-status`));
  }

  /**
   * getContextBot
   */
  public getContextBot() {
    return firstValueFrom(this.http.get<any>(`${environment.apiUrl}/bot-whatsapp/context`));
  }

  /**
   * saveContextBot
   */
  public saveContextBot(data: any) {
    return firstValueFrom(this.http.post<any>(`${environment.apiUrl}/bot-whatsapp/contex`, data));
  }
}
